export const checkIfProductIsInUserCollection = ( productID, collections) => {
    const foundProduct = collections?.wish_list_merchandise?.find(merchandise => merchandise.id === productID );
    if(foundProduct) return true;
    return false;
}